import React from "react";

export default function PageHeader({ eyebrow, title, action }) {
  return (
    <div className="px-6 md:px-10 pt-8 pb-5 mj-rule flex items-end justify-between gap-4 flex-wrap">
      <div>
        {eyebrow && (
          <div className="data-label mb-2" data-testid="page-eyebrow">
            {eyebrow}
          </div>
        )}
        <h1
          className="font-display text-4xl md:text-5xl font-black tracking-tight"
          data-testid="page-title"
        >
          {title}
        </h1>
      </div>
      {action && <div className="flex gap-2 items-center">{action}</div>}
    </div>
  );
}
